module.exports = __webpack_public_path__ + "img/banner-4.9e2dfce5.jpg";